import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div className="text-center text-title pb-3">
        Developed by George Falkovich (c) 2020
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js